/********************************************************************************/

import * as javascript from "@radically-straightforward/javascript/static/index.mjs";


/********************************************************************************/

javascript?.execute?.functions?.set?.("bpeohhzjsgsuwd", async function() {
  try {
    this.midi = [...(await navigator.requestMIDIAccess()).outputs.values()][0];
  } catch (error) {
    alert(error);
  }
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("dxwhvghlqdyexo", async function() {
  this.isModified = false;
  this.oninput = () => {
    window.history.pushState(
      null,
      "",
      "?" + new URLSearchParams(javascript.serialize(this)).toString(),
    );
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("ecldvhygpwafuu", async function() {
  this.ontouchstart = () => {
    const element = document.querySelector('[name="octave"]');
    const value = Number(element.value) - 1;
    if (value < -8) return;
    element.value = (0 <= value ? "+" : "") + String(value);
    element.dispatchEvent(new Event("input", { bubbles: true }));
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("bydecnhzoyhhmj", async function() {
  const value = Number(new URL(window.location).searchParams.get("octave"));
  this.value = Number.isNaN(value)
    ? "+0"
    : (0 <= value ? "+" : "") + String(value);
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("ghnyapjqnfzzvv", async function() {
  this.ontouchstart = () => {
    const element = document.querySelector('[name="octave"]');
    const value = Number(element.value) + 1;
    if (8 < value) return;
    element.value = (0 <= value ? "+" : "") + String(value);
    element.dispatchEvent(new Event("input", { bubbles: true }));
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("hezbymhqwcaifa", async function() {
  this.ontouchstart = () => {
    document.querySelector("html").requestFullscreen();
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("dtyrzkgndiyzpb", async function() {
  this.ontouchstart = () => {
    document.exitFullscreen();
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("ejlvweotgxpyhs", async function() {
  const tuning = [64, 59, 55, 50, 45, 40];
  const voices = new Map();
  this.ontouchstart = (event) => {
    if (!event.target.matches('[key~="button"]')) return;
    const note =
      tuning[event.target.row] +
      event.target.column +
      12 * Number(document.querySelector('[name="octave"]').value);
    if (note < 0 || 127 < note) return;
    document.querySelector("body").midi.send([0b10010000, note, 64]);
    voices.set(event.target, note);
    javascript.stateAdd(event.target, "active");
  };
  this.ontouchend = (event) => {
    if (!event.target.matches('[key~="button"]')) return;
    const note = voices.get(event.target);
    if (note === undefined) return;
    document.querySelector("body").midi.send([0b10000000, note, 64]);
    voices.delete(event.target);
    javascript.stateRemove(event.target, "active");
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("bhqbrtrejfnbec", async function($$0, $$1) {
  this.row = $$0;
  this.column = $$1;
}
);

